import { MapfreButtonComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/individual-components/inputs/mapfre-button/mapfre-button.component';
import { MapfreIputWithValidationComponent } from '../../../../modules/mapfre-design-library/src/lib/_components/section-components/mapfre-input-with-validation/mapfre-input-with-validation.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { StorageServiceObservablesService } from './../../../../_services/storage-service-observables/storage-service-observables.service';

import { Component, OnInit, Input } from '@angular/core';
import {
  FormBaseControlService,
  FormBase,
  AlertService,
  GTagService,
  AcmicService,
} from '@mapfre-design-library/src/public_api';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, ActivatedRoute, RouterModule } from '@angular/router';
import { AuthenticateUserService } from './../../../../_services/profile-settings/authenticate-user.service';
import { ChangeProfileEmailService } from '../../../../_services/profile-settings/change-profile-email.service';
import { ProfileSettingsRoutingService } from '../../../../_services/profile-settings/profile-settings-routing.service';
import { PaperlessService } from '../../../../_services/_iam/paperless.service';
import { ErrorRedirectionService } from '../../../../_services/error-service/error-redirection.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MapfreIputWithValidationComponent, MapfreButtonComponent],
  selector: 'app-change-password-form',
  templateUrl: './change-password-form.component.html',
  providers: [FormBaseControlService],
})
export class ChangePasswordFormComponent implements OnInit {
  @Input() inputs: FormBase<any>[] = [];
  @Input() userData: any;
  changePasswordForm: FormGroup;
  isAcmic = false;
  forgotPassword = false;
  wrongPassword = false;
  whereInTheProcess: string;
  previousURL: any;
  loader = false;
  constructor(
    private alertService: AlertService,
    private activatedRoute: ActivatedRoute,
    private authenticateUserService: AuthenticateUserService,
    private changeProfileEmailService: ChangeProfileEmailService,
    private ipt: FormBaseControlService,
    public router: Router,
    private passwordProcess: ProfileSettingsRoutingService,
    private storageService: StorageServiceObservablesService,
    private paperlessService: PaperlessService,
    private errorRedirectionService: ErrorRedirectionService,
    private acmicService: AcmicService,
    private gTagService: GTagService,
    private translate: TranslateService
  ) { }

  onConfirmChange() {
    if (this.loader) {
      return false;
    }
    this.loader = true;
    const passwd = this.changePasswordForm.controls.changePassword.value;
    const password = window.btoa(passwd);
    this.authenticateUserService
      .authenticateCurrentPassword(password)
      .subscribe(
        () => {
          this.gTagService.triggerFormLink('changePasswordForm', 'true', '');
          this.loader = false;
          if (this.whereInTheProcess == 'enter-password') {
            this.passwordProcess.setPasswordProcess(true);
            this.passwordProcess.setOldPassword(passwd);
            this.router.navigate(['/profile', 'edit-password']);
          } else if (this.whereInTheProcess == 'verify-password') {
            this.changeProfileEmailService.saveProcess(true);
            this.router.navigate(['/profile', 'edit-email']);
          }
        },
        (error) => {
          this.loader = false;
          this.gTagService.triggerFormLink(
            'changePasswordForm',
            'false',
            this.translate.instant('CHANGE_PASSWORD_ERROR')
          );
          if (
            error.status === 400 ||
            error.status === 401 ||
            error.status === 403 ||
            error.status === 404 ||
            error.status === 408
          ) {
            this.forgotPassword = true;
            this.changePasswordForm.controls['changePassword'].setErrors({
              invalid: true,
            });
            this.alertService.error('ENTER_A_VALID_PASSWORD');
          } else {
            this.errorRedirectionService.errorRedirectHandler(error);
          }
        }
      );
  }

  prefillEmailParamater() {
    const email = this.storageService.getUserFromStorage();
    this.router.navigate(['/profilepassword', !email ? '' : email]);
  }

  onCancel() {
    if (this.previousURL === '/billing/paperless') {
      this.router.navigate(['/billing/paperless']);
    } else {
      this.router.navigate(['/profile']);
    }
  }

  ngOnInit() {
    this.isAcmic = this.acmicService.isACMIC();
    this.whereInTheProcess = this.activatedRoute.snapshot.routeConfig.path;
    this.changePasswordForm = this.ipt.toFormGroup(this.inputs);
    this.previousURL = this.paperlessService.getCurrentRoute();
  }
}
